import { ReactElement } from "react"
import { FormattedMessage } from "react-intl"
import { AccentButton } from "shared/components/buttons/AccentButton"
import { TextButton } from "shared/components/buttons/TextButton"
import styled from "styled-components"

import {
  ModalText,
  PanelModal,
} from "../../../shared/components/PanelModal"

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  & button:not(:last-of-type) {
    margin-right: 12px;
  }
`

export type ConfirmationModalProps = {
  close: () => void
  action: (callback: () => void) => void
  messageText: ReactElement
  buttonText: ReactElement
}

const ConfirmationModal = ({
  messageText,
  close,
  action,
  buttonText,
}: ConfirmationModalProps) => (
  <PanelModal
    closeModal={close}
    closeButtonRobotTag="chat-confirmation-modal-close-button"
  >
    <Body>
      <ModalText>{messageText}</ModalText>
      <ButtonContainer>
        <TextButton onClick={close} data-robot="confirmation-modal-cancel">
          <FormattedMessage
            id="confirmationModal.cancel"
            defaultMessage="Cancel"
          />
        </TextButton>
        <AccentButton
          onClick={() => action(close)}
          data-robot="confirmation-modal-confirm"
        >
          {buttonText}
        </AccentButton>
      </ButtonContainer>
    </Body>
  </PanelModal>
)

export default ConfirmationModal
